<script setup>
defineProps({
  name: { type: String, required: true },
  size: { type: [Number, String], default: 16 },
});

const NAME_TO_DX = {
  pencil: "edit",
  "trash-2": "trash",
  history: "clock",
  copy: "copy",
  "settings-2": "preferences",
  zap: "refresh",
  plus: "add",
  "list-checks": "todo",
  palette: "palette",
  "toggle-right": "check",
  "toggle-left": "close",
  download: "download",
  "key-round": "key",
  "door-open": "unlock",
  smartphone: "tel",
  maximize: "fullscreen",
  "arrow-left-right": "movetofolder",
  settings: "optionsgear",
  "rotate-ccw": "revert",
  list: "bulletlist",
  monitor: "detailslayout",
  info: "info",
  play: "runner",
  eraser: "clear",
  ban: "clearsquare",
  x: "close",
  "circle-plus": "plus",
  tablet: "card",
};
</script>

<template>
  <i
    class="dx-icon"
    :class="`dx-icon-${NAME_TO_DX[name] || name}`"
    :style="{ fontSize: typeof size === 'number' ? `${size}px` : size }"
  ></i>
</template>
